export type ReadState = { since: number; opened: Record<string, string> };

function key(mapId: string, viewerId: string): string {
  return `map-read:${mapId}:${viewerId}`;
}

export function loadReadState(mapId: string, viewerId: string): ReadState {
  const storageKey = key(mapId, viewerId);
  try {
    const saved = JSON.parse(localStorage.getItem(storageKey) ?? "null") as Partial<ReadState> | null;
    if (saved && typeof saved.since === "number" && Number.isFinite(saved.since) &&
        saved.opened && typeof saved.opened === "object" && !Array.isArray(saved.opened)) {
      return { since: saved.since, opened: saved.opened as Record<string, string> };
    }
  } catch { /* An invalid or unavailable store starts a fresh read history. */ }
  const initial = { since: Date.now(), opened: {} };
  try { localStorage.setItem(storageKey, JSON.stringify(initial)); } catch { /* Browsing still works without storage. */ }
  return initial;
}

export function hasUnreadRevision(state: ReadState | null, topicId: string, updatedAt?: string): boolean {
  if (!state || !updatedAt) return false;
  const updated = Date.parse(updatedAt);
  return Number.isFinite(updated) && updated > state.since &&
    (state.opened[topicId] === undefined || Date.parse(state.opened[topicId]) < updated);
}

export function rememberRead(mapId: string, viewerId: string, state: ReadState, topicId: string, updatedAt: string): ReadState {
  if (state.opened[topicId] === updatedAt) return state;
  const next = { ...state, opened: { ...state.opened, [topicId]: updatedAt } };
  try { localStorage.setItem(key(mapId, viewerId), JSON.stringify(next)); } catch { /* Keep this visit's state in memory. */ }
  return next;
}
